import * as React from "react";
import {useContext, useEffect, useRef, useState} from "react";
import {MensagemContext} from "../../context/MensagemContext";
import {MensagemContextType} from "../../context/MensagemContextType";
import Restaurante from "../../model/Restaurante";
import rest from "../../utils/EnvConfig";
import {ItemEditViewColuna} from "../../component/ItemEditViewColuna";
import Texto from "../../component/form/texto/Texto";
import MoedaBancario from "../../component/form/moeda-bancario/MoedaBancario";
import Switch from "../../component/form/switch/Switch";
import ItemEditView from "../../component/ItemEditView";
import RestauranteCardapioComidaItem from "../../model/RestauranteCardapioComidaItem";
import ItemEditState from "../../component/ItemEditState";
import DinheiroUtils from "../../utils/DinheiroUtils";
import EditView from "src/component/EditView";
import RestauranteCardapioComida from "../../model/RestauranteCardapioComida";
import MultiCombo from "../../component/form/multi-combo/MultiCombo";
import {Ajax} from "../../utils/Ajax";
import GrupoComidaSearch from "../../component/form/grupo/GrupoComidaSearch";
import {Button} from "primereact/button";
import {PrimeIcons} from "primereact/api";
import styles from "./Restaurante.module.css";
import {useNavigate} from "react-router-dom";
import {useKeycloak} from "../../keycloak/useKeycloak";
import {TipoUsuarioKeycloak} from "../../keycloak/TipoUsuarioKeycloak";

function RestauranteCardapioComidaEdit() {
    const {hasRole, user, token} = useKeycloak();
    const [controleSalvamentoAutomatico, setControleSalvamentoAutomatico] = useState(-1);
    const navigate = useNavigate();
    const itensCardapioTitleRef = useRef<any>();
    const cardapioTitleRef = useRef<any>();
    const nomeCardapioRef = useRef<any>();
    const {info, error} = useContext(MensagemContext) as MensagemContextType;
    const [itemEditState] = useState<ItemEditState>(new ItemEditState());
    const [cardapio, setCardapio] = useState<RestauranteCardapioComida>(new RestauranteCardapioComida());
    const [cardapioItem, setCardapioItem] = useState<RestauranteCardapioComidaItem>(new RestauranteCardapioComidaItem());
    const [restaurantes, setRestaurantes] = useState<Restaurante[]>([]);
    const [destaqueCardapioComida, setDestaqueCardapioComida] = useState(cardapioItem.destaque ? cardapioItem.destaque : false);
    const [statusCardapioComida, setStatusCardapioComida] = useState(cardapioItem.status ? cardapioItem.status : true);

    let validacaoNomeCardapioFunction: any;

    useEffect(() => {
        Ajax.of()
            .error(error)
            .setTokenKeycloak(token!)
            .obterTodosCustom(obterRecursoRestaurantesCorreto(), (data) => {
                setRestaurantes(data);
            });
    }, []);

    useEffect(() => {
        setControleSalvamentoAutomatico(prevState => prevState + 1);

        if (!cardapio.id && controleSalvamentoAutomatico >= 0) {
            if (cardapio.itens && cardapio.itens.length !== 0 && !itemEditState.state) {
                salvarCardapio();
            }
        } else if (cardapio.id && controleSalvamentoAutomatico > 0) {
            if (cardapio.itens && cardapio.itens.length !== 0 && !itemEditState.state) {
                salvarCardapio();
            }
        }
    }, [cardapio.itens]);

    useEffect(() => {
        validacaoNomeCardapioFunction = setTimeout(async () => {
            await validarNomeCardapio();
            clearTimeout(validacaoNomeCardapioFunction);
        }, 0);
    }, [cardapio.nomeCardapio, cardapio.restaurantes]);

    const salvarCardapio = async (endLoadingFunc?: () => void) => {
        if (await validar()) {
            await Ajax.of()
                .error(error)
                .setTokenKeycloak(token!)
                .salvarRegistro(`${rest.restauranteCardapioComida}`,
                    cardapio, (entidade: any) => {
                        cardapio.id = entidade.id;
                        cardapio.uuid = entidade.uuid;
                        info("Cardápio salvo com sucesso");
                        if (endLoadingFunc) endLoadingFunc();
                    }, err => {
                        if (endLoadingFunc) endLoadingFunc();
                    });
        }
    };

    const obterRecursoRestaurantesCorreto = (): string | undefined => {
        if (hasRole(TipoUsuarioKeycloak.ADMIN)) {
            return `${rest.restaurante}/${rest.obterTodos}`;
        }

        if (hasRole(TipoUsuarioKeycloak.CLIENTE)) {
            return `${rest.restaurante}/${rest.restaurantesPorUsuario}${user.id}`;
        }

        return "";
    }

    const cardapioOnChangeHandler = (e: any) => {
        setCardapio({ ...cardapio, [e.target.id]: e.target.value });
    }

    const validarRestauranteCardapioComidas = (onSuccess: () => void) => {
        if (!cardapioItem.grupo) {
            error("Grupo é obrigatório");
            return;
        }

        if (!cardapioItem.nome) {
            error("Nome do prato é obrigatório");
            return;
        }

        if (!cardapioItem.unidadeMedida) {
            error("Unidade de medida é obrigatório");
            return;
        }

        if (!cardapioItem.quantidadePessoas) {
            error("Quantas pessoas serve é obrigatório");
            return;
        }

        if (!cardapioItem.valor) {
            error("Valor do prato é obrigatório");
            return;
        }

        if (cardapioItem.destaque) {
            for (const item of cardapio.itens || []) {
                if (item.destaque) {
                    error("Já existe um item como prato destaque")
                    return;
                }
            }
        }

        onSuccess();
    }

    const adicionarRestauranteCardapioComidas = () => {
        validarRestauranteCardapioComidas(() => {
            if (cardapio.itens !== undefined) {
                // TODO Gambiarra, verificar uma forma melhor pra esconder o placeholder para não gerar confusão para o usuário
                if (cardapioItem.observacao && cardapioItem.observacao === " ") {
                    cardapioItem.observacao = cardapioItem.observacao.trim();
                }

                setCardapio(prevEntidade => ({
                    ...prevEntidade,
                    // @ts-ignore
                    itens: [...prevEntidade.itens, cardapioItem]
                }));

                setCardapioItem(new RestauranteCardapioComidaItem());
                setDestaqueCardapioComida(false);
                setStatusCardapioComida(true);

                itemEditState.limparState();

                scrollItensCardapioTitle();
            }
        });
    }

    const editarRestauranteCardapioComidas = (item: RestauranteCardapioComidaItem) => {
        if (itemEditState.state) {
            error(`Já existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return;
        }

        itemEditState.buildItemState("Cardápio - Comida", item);

        // TODO Gambiarra, verificar uma forma melhor pra esconder o placeholder para não gerar confusão para o usuário
        if (!item.observacao) {
            item.observacao = " ";
        }

        scrollItensCardapioTitle();

        setCardapioItem(item);
        if (cardapio.itens !== undefined) {
            setCardapio({ ...cardapio, itens: [...cardapio.itens.filter(t => t !== item)] });
        }
    }

    const removerRestauranteCardapioComidas = (item: RestauranteCardapioComidaItem) => {
        if (cardapio.itens !== undefined) {
            setCardapio({ ...cardapio, itens: [...cardapio.itens.filter(t => t !== item)] });
        }
    }

    const switchDestaqueCardapioComidaOnChangeHandler = (e: any) => {
        setDestaqueCardapioComida(e.value);
        setCardapioItem({ ...cardapioItem, destaque: e.value });
    }

    const switchCardapioComidaOnChangeHandler = (e: any) => {
        setStatusCardapioComida(e.value);
        setCardapioItem({ ...cardapioItem, status: e.value });
    }

    const cardapioComidaOnChangeHandler = (e: any) => {
        setCardapioItem({ ...cardapioItem, [e.target.id]: e.target.value });
    }

    const cardapioComidaMoedaOnChangeHandler = (value: number, valueCorrigido?: number) => {
        setCardapioItem({ ...cardapioItem, valor: valueCorrigido });
    }

    const valorRestauranteCardapioComidaTemplate = (item: RestauranteCardapioComidaItem) => {
        if (item.valor) {
            return DinheiroUtils.formatToDinheiro(item.valor);
        }
        return "R$ 0,00";
    };

    const grupoCardapioComidaTemplate = (item: RestauranteCardapioComidaItem) => {
        if (item.destaque) {
            return `* ${item.grupo?.nome}`;
        }
        return item.grupo?.nome || "";
    };

    const statusRestauranteCardapioComidaTemplate = (item: RestauranteCardapioComidaItem) => {
        return item.status ? "Sim" : "Não";
    };
    // ------

    const editEntidade = (data: RestauranteCardapioComida) => {
        setCardapio(data);
    }

    const validar = async (): Promise<boolean> => {
        if (itemEditState.state) {
            error(`Existe um item sendo editado em ${itemEditState.nomeSessaoItem}`);
            return false;
        }

        if (!cardapio.nomeCardapio) {
            error(`Nome do cardápio é obrigatório`);
            return false;
        }

        if (!cardapio.restaurantes || cardapio.restaurantes.length === 0) {
            error(`Selecione ao menos um restaurante`);
            return false;
        }

        if (cardapio.itens) {
            const itensSemGrupo = cardapio.itens.filter(i => !i.grupo).length;
            if (itensSemGrupo > 0) {
                error(`Existem itens do cardápio sem grupo`);
                return false;
            }
        }

        return true;
    };

    const scrollItensCardapioTitle = () => {
        if (itensCardapioTitleRef.current) {
            itensCardapioTitleRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const scrollCardapioTitle = () => {
        if (cardapioTitleRef.current) {
            cardapioTitleRef.current.scrollIntoView({ behavior: "smooth" });
        }
    }

    const navegarParaFotos = async () => {
        if (await validar()) {
            await Ajax.of()
                .info(info)
                .error(error)
                .setTokenKeycloak(token!)
                .salvarRegistro(`${rest.restauranteCardapioComida}`, cardapio, (response: any) => {
                    navigate(`/restaurante/cardapio/comida/imagem/${response.uuid}`);
                }, () => {
                    error("Houve um problema ao tentar salvar.");
                });
        }
    }

    const validarNomeCardapio = async () => {
        if (cardapio.nomeCardapio && cardapio.restaurantes!.length > 0) {
            await Ajax.of()
                .setTokenKeycloak(token!)
                .postRegistroCustom(`${rest.server}${rest.restauranteCardapioComida}/${rest.cardapiosComidaValidarNome}`, cardapio, (response: any) => {
                }, (err: Error) => {
                    error(err.message);
                    setCardapio(new RestauranteCardapioComida());
                    setCardapioItem(new RestauranteCardapioComidaItem());
                    nomeCardapioRef.current.focus();
                    scrollCardapioTitle();
                });
        }
    }

    const botoesExtra = (entidade: RestauranteCardapioComidaItem, rowIndex?: number): React.JSX.Element[] => {
        return [
            (
                <>
                    <Button icon={PrimeIcons.CAMERA} className={`${styles.espacamentoBotoes} mr-2`} raised
                            title={"Envio de fotos"} onClick={(event: any) => navegarParaFotos()}
                            severity="success" />
                </>
            )];
    }

    return (
        <>
            <div ref={cardapioTitleRef}></div>
            <EditView title={"Restaurante - Cardápio de comida"}
                      id={`${rest.restauranteCardapioComida}`}
                      entidade={cardapio}
                      onValidationHandler={validar}
                      onSalvarHandler={salvarCardapio}
                      sairAoSalvar={false}
                      entidadeUseStateFunction={editEntidade}>

                <Texto id={"nomeCardapio"} label={"* Título do cardápio"} value={cardapio.nomeCardapio} maxLength={20}
                       placeholder={"Ex: Cardápio geral"}
                       size={"100%"} ref={nomeCardapioRef}
                       onChangeHandler={cardapioOnChangeHandler}/>

                <MultiCombo values={restaurantes} id={"restaurantes"}
                            label={"Selecione os restaurantes que desejar usar esse cardápio"}
                            value={cardapio.restaurantes}
                            optionLabel={"nomeEstabelecimento"}
                            onChangeHandler={cardapioOnChangeHandler}/>

                <div ref={itensCardapioTitleRef}></div>
                <ItemEditView id={"restauranteCardapioComida"}
                              title={"Itens do cardápio"}
                              adicionarFunction={adicionarRestauranteCardapioComidas}
                              editarItemFunction={editarRestauranteCardapioComidas}
                              removerItemFunction={removerRestauranteCardapioComidas}
                              itens={cardapio.itens}
                              botoesAdicionais={botoesExtra}
                              colunas={[
                                  ItemEditViewColuna.of("grupo.nome", "Grupo", grupoCardapioComidaTemplate),
                                  ItemEditViewColuna.of("nome", "Nome prato"),
                                  ItemEditViewColuna.of("unidadeMedida", "Tamanho"),
                                  ItemEditViewColuna.of("valor", "Valor", valorRestauranteCardapioComidaTemplate),
                                  ItemEditViewColuna.of("quantidadePessoas", "Quantas pessoas"),
                                  ItemEditViewColuna.of("status", "Ativo", statusRestauranteCardapioComidaTemplate)
                              ]}>

                    <div className="formgrid grid">
                        <div className="field col">
                            <GrupoComidaSearch id={"grupo"} label={"* Grupo"} value={cardapioItem.grupo}
                                               placeholder={"Ex: Massas"}
                                               fullSize={true} cardapio={cardapio}
                                               maxLength={20}
                                               onChangeHandler={cardapioComidaOnChangeHandler}
                            />
                        </div>
                        <div className="field col">
                            <Texto id={"nome"} label={"* Nome do prato"} value={cardapioItem.nome} maxLength={20}
                                   placeholder={"Ex: Ravioli ao molho de nozes"}
                                   fullSize={true}
                                   onChangeHandler={cardapioComidaOnChangeHandler}/>
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col">
                            <Texto id={"unidadeMedida"} label={"* Tamanho"} value={cardapioItem.unidadeMedida}
                                   maxLength={20} fullSize={true}
                                   placeholder={"Ex: Kg"}
                                   onChangeHandler={cardapioComidaOnChangeHandler}/>
                        </div>
                        <div className="field col">
                            <Texto id={"quantidadePessoas"} label={"* Para quantas pessoas?"} keyFilter={"pint"}
                                   placeholder={"Ex: 1"}
                                   maxLength={2} fullSize={true}
                                   value={cardapioItem.quantidadePessoas}
                                   onChangeHandler={cardapioComidaOnChangeHandler}/>
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col">
                            <MoedaBancario id={"valor"} label={"* Valor"} value={cardapioItem.valor}
                                           maxLength={999999} fullSize={true}
                                           onValueChangeHandler={cardapioComidaMoedaOnChangeHandler}/>
                        </div>
                        <div className="field col">
                            <Texto id={"observacao"} label={"Detalhes"} value={cardapioItem.observacao}
                                   placeholder={"Ex: Ravioli recheado com queijo e servido com um delicioso molho de nozes."}
                                   maxLength={100} fullSize={true}
                                   onChangeHandler={cardapioComidaOnChangeHandler}/>
                        </div>
                    </div>

                    <div className="formgrid grid">
                        <div className="field col">
                            <Switch checked={destaqueCardapioComida} id={"destaque"} label={"Prato destaque"}
                                    explicacao={"Prato destaque será marcado com * na lista abaixo"}
                                    onChangeHandler={switchDestaqueCardapioComidaOnChangeHandler}/>

                        </div>
                        <div className="field col">
                            <Switch checked={statusCardapioComida} id={"status"}
                                    label={statusCardapioComida ? "Ativo" : "Inativo"}
                                    onChangeHandler={switchCardapioComidaOnChangeHandler}/>
                        </div>
                    </div>
                </ItemEditView>
            </EditView>
        </>
    );
}

export default RestauranteCardapioComidaEdit;